/* global SWDLocalise */
import tingle from 'tingle.js';
import form from '../form';
import { setCookie, getCookie } from '../cookie';
import { handleResponse } from '../../utils';

const getLinks = () => document.querySelectorAll('.js-modal');

const euCountryCodes = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HU', 'HR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];

const getCountryCode = () => (
    new Promise((resolve) => {
        fetch(`${SWDLocalise.homeUrl}/api/countrycode`, {
            method: 'GET',
            cache: 'no-cache',
        })
            .then(handleResponse)
            .then((response) => {
                if (response?.countryCode !== undefined) {
                    return resolve(response.countryCode);
                }
                return resolve('GB');
            })
            .catch(() => {
                resolve('GB');
            });
    })
);

const setGeoModalCookie = () => {
    setCookie(`spb${SWDLocalise.theme}-hide-geo-modal`, '1', 30);
};

const doPopup = (event) => {
    const e = event || window.event;
    const t = (e.currentTarget ? e.currentTarget : e.srcElement);
    const width = 800;
    const height = 500;

    // popup position
    const px = Math.floor(((window.screen.availWidth || 1024) - width) / 2);
    const py = Math.floor(((window.screen.availHeight || 700) - height) / 2);

    // open popup
    const popup = window.open(t.href, 'social', `width=${width},height=${height},left=${px},top=${py},location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1`);

    if (popup) {
        popup.focus();
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
    }

    return !!popup;
};

const handleShareLinks = () => {
    const clickTargets = document.querySelectorAll('.js-copy-text');
    if (clickTargets.length > 0) {
        clickTargets.forEach((clickTarget) => {
            clickTarget.onclick = () => {
                clickTarget.classList.add('is-copied');
                document.execCommand('copy');
                setTimeout(() => {
                    clickTarget.classList.remove('is-copied');
                }, 100);
            };

            clickTarget.addEventListener('copy', (event) => {
                event.preventDefault();
                if (event.clipboardData) {
                    event.clipboardData.setData('text/plain', clickTarget.dataset.text);
                }
            });
        });
    }

    const shareLinks = document.querySelectorAll('.js-share');
    if (shareLinks.length > 0) {
        shareLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                doPopup(event);
            });
        });
    }
};

export const openModal = (
    content,
    closeCallback = false,
    openCallback = false,
    cssClass = false,
) => {
    // set options
    const opts = {
        stickyFooter: false,
        closeMethods: ['overlay', 'escape'],
        closeLabel: 'Close',
        onClose: () => {
            if (closeCallback) closeCallback();

            // remove modals
            const modals = document.querySelectorAll('.tingle-modal');
            modals.forEach((el) => el.remove());
        },
    };

    if (cssClass) {
        opts.cssClass = [cssClass];
    }

    if (openCallback) {
        opts.onOpen = () => {
            openCallback();
        };
    }

    // init
    const modal = new tingle.modal(opts); // eslint-disable-line new-cap

    // set content
    modal.setContent(content);

    // open modal
    modal.open();

    // close button
    const closeBtns = modal.modal.querySelectorAll('.js-modal-close');
    if (closeBtns.length > 0) {
        closeBtns.forEach((closeBtn) => {
            closeBtn.addEventListener('click', (event) => {
                event.preventDefault();
                modal.close();
            });
        });
    }
};

const setNewsletterModalCookie = () => {
    setCookie(`spb${SWDLocalise.theme}-hide-newsletter-modal`, '1', 30);
};

const initModalForm = () => form();

const getDocHeight = () => {
    const D = document;
    return Math.max(
        D.body.scrollHeight,
        D.documentElement.scrollHeight,
        D.body.offsetHeight,
        D.documentElement.offsetHeight,
        D.body.clientHeight,
        D.documentElement.clientHeight,
    );
};

const amountscrolled = () => {
    const winheight = window.innerHeight || (
        document.documentElement
        || document.body
    ).clientHeight;
    const docheight = getDocHeight();
    const scrollTop = window.pageYOffset || (
        document.documentElement
        || document.body.parentNode
        || document.body
    ).scrollTop;
    const trackLength = docheight - winheight;

    // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)
    const pctScrolled = Math.floor((scrollTop / trackLength) * 100);

    return pctScrolled;
};

const init = () => {
    // handle share links modal
    const links = getLinks();
    if (links.length > 0) {
        links.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                const content = document.querySelector(`.js-modal-content[data-modal=${link.dataset.modal}]`).innerHTML;
                openModal(
                    content,
                    false,
                    handleShareLinks,
                    link.dataset.class || false,
                );
            });
        });
    }

    // handle newsletter modal
    if (!getCookie(`spb${SWDLocalise.theme}-hide-newsletter-modal`)) {
        let modalNewsletterOpen = false;
        const modalNewsletter = document.querySelector('.js-newsletter-modal');

        if (modalNewsletter) {
            window.addEventListener('scroll', () => {
                if (getCookie(`spb${SWDLocalise.theme}-hide-newsletter-modal`)) return;

                if (!modalNewsletterOpen && amountscrolled() >= 50) {
                    modalNewsletterOpen = !modalNewsletterOpen;
                    openModal(
                        modalNewsletter.innerHTML.replace(/newsletter-modal-consent/g, 'newsletter-modal-consent-new'),
                        setNewsletterModalCookie,
                        initModalForm,
                        'c-newsletter-modal',
                    );
                }
            }, false);
        }
    }

    // handle geo target modal
    if (SWDLocalise.theme !== 'es' && !getCookie(`spb${SWDLocalise.theme}-hide-geo-modal`)) {
        getCountryCode().then((countryCode) => {
            // console.table({
            //     theme: SWDLocalise.theme,
            //     countryCode,
            // });

            // do not show modal if user and theme countries match
            if ((SWDLocalise.theme === 'uk' && euCountryCodes.includes(countryCode))
                || (SWDLocalise.theme === 'us' && euCountryCodes.indexOf(countryCode) === -1)) {
                setGeoModalCookie();
                return;
            }

            const modalGeo = `
                <span class="c-geo_close js-modal-close">
                    <svg class="c-icon"><use xlink:href="#icon-close"></use></svg>
                </span>
                <img
                    src="${SWDLocalise.mediaUrl}/gfx/geo-locate/flag-${SWDLocalise.theme === 'uk' ? 'us' : 'uk'}.svg"
                    class="o-mb40 c-image"
                    alt="Flag of ${SWDLocalise.theme === 'uk' ? 'USA' : 'UK'}">
                <h2 class="text-3xl o-mb50 u-font-ba">
                    ${SWDLocalise.theme === 'uk' ? `
                        It looks like you are based <br class="hidden lg:block">outside the UK
                    ` : `
                        It looks like you are based <br class="hidden lg:block">in the UK/Europe
                    `}
                </h2>
                <a
                    href="${SWDLocalise.theme === 'uk' ? 'https://stpierrebakery.com/' : 'https://stpierrebakery.co.uk/'}"
                    class="o-mb30 c-btn">Go to St Pierre ${SWDLocalise.theme === 'uk' ? 'USA' : 'UK'}</a>
                <span role="button" class="c-text-btn u-type-xs js-modal-close">No, thank you</span>
            `;

            openModal(
                modalGeo,
                setGeoModalCookie,
                false,
                'c-geo-modal',
            );
        }).catch((error) => {
            console.error(error); // eslint-disable-line no-console
        });
    }
};

export default init;
